
const VERSION = {
  SHA1:'ecc1a84ad30080a60c1f87bf4156f4146e370800',
  VERSION:2342,
  BRANCH:'main',
  PROJECT:'ostium-ne'
}
export default VERSION;
